export default {
  // Your mock implementation
};
